
import { DxTabPanel, DxItem } from 'devextreme-vue/tab-panel';

import HabilidadTab from './serviciolistadodocumentacion.vue';
import EtapaTab from './serviciogrupoetapa.vue';
//import InfTab from './serviciolistadoinformacion.vue';
import InfTab from './serviciogrupolistadoinformacion.vue';
export default {
  components: {
    DxTabPanel, DxItem, HabilidadTab, EtapaTab, InfTab
  },
  props: {
    masterDetailData: {
      type: Object,
      default: () => ({}),
    },
  },
};
